import { useState, useRef, useEffect } from 'react';

export const useDuration = ({
  duration,
  active = true
}: {
  duration: number;
  active?: boolean;
}) => {
  const [cursor, setCursor] = useState(0);
  const timeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (active) {
      timeout.current = setInterval(() => setCursor(n => n + 1), duration);
    }

    if (!active) {
      timeout.current && clearInterval(timeout.current);
    }

    return () => timeout.current && clearInterval(timeout.current);
  }, [active, duration]);

  return { cursor };
};
